import createLogStream from '../api/createLogStream';
import logCloudWatchEvents from '../api/logCloudWatchEvents';
import { TConfig } from 'lib/common/types/Config';
import TFetch from 'lib/common/types/Fetch';
import { LogEntry } from '../../LogStoreContext/Context';
import isMissingLogStreamError from './isMissingLogStreamError';

type UploadLogsWithStreamRecoveryParams = {
  fetch_: TFetch;
  config: TConfig;
  logs: LogEntry[];
};

async function uploadLogsWithStreamRecovery({
  fetch_,
  config,
  logs,
}: UploadLogsWithStreamRecoveryParams): Promise<void> {
  try {
    await logCloudWatchEvents({
      fetch_,
      config,
      logs,
    });
  } catch (error) {
    if (!isMissingLogStreamError(error)) {
      throw error;
    }

    await createLogStream({ fetch_, config });

    /*
    If the error was due to missing log stream, we create the log stream and then attempt to re-upload the same logs. 
    If we catch an error again, we throw it so that it can be handled and potentially retried with backoff. 
    We don't want to retry indefinitely in this function because if the error is due to 
    something other than a missing log stream (eg unable to find log stream, invalid path, or log stream initially did not exist in the first place) 
    we don't want to get stuck in a never ending loop of creating log streams and retrying uploads.
    */
    throw error;
  }
}

export default uploadLogsWithStreamRecovery;
